import { render, staticRenderFns } from "./AddNewAccount.vue?vue&type=template&id=5a485cd4&scoped=true"
import script from "./AddNewAccount.vue?vue&type=script&lang=js"
export * from "./AddNewAccount.vue?vue&type=script&lang=js"
import style0 from "./AddNewAccount.vue?vue&type=style&index=0&id=5a485cd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a485cd4",
  null
  
)

export default component.exports